import React, { Component } from "react"
import { withStyles } from "@mui/styles"
import Tooltip from "@mui/material/Tooltip"
import SvgIcon from "@mui/material/SvgIcon"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import linkifyHtml from "linkify-html"
import { sanitizeYaml } from "../../utilities"

const CustomTooltip = withStyles({
  tooltipPlacementTop: {
    marginBottom: "8px",
    filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))",
  },
  tooltip: { backgroundColor: "white", color: "black", borderRadius: "8px" },
  arrow: { color: "white" },
})(Tooltip)

export default class Hotspots extends Component {
  state = { screenAspectRatio: null, pictureAspectRatio: null }

  computeScreenAspectRatio = () => {
    this.setState({ screenAspectRatio: window.innerWidth / window.innerHeight })
  }

  computeBackgroundAspectRatio = (background) => {
    const img = new Image()
    img.onload = () => {
      this.setState({
        pictureAspectRatio: img.width / img.height,
      })
    }
    img.src = background
  }

  componentDidMount() {
    this.computeBackgroundAspectRatio(this.props.background)
    this.computeScreenAspectRatio()
    window.addEventListener("resize", this.computeScreenAspectRatio)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.computeScreenAspectRatio)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.background !== nextProps.background) {
      this.computeBackgroundAspectRatio(nextProps.background)
    }
  }

  render() {
    const { hotspots, parentAspectRatio } = this.props
    const { screenAspectRatio, pictureAspectRatio } = this.state

    return pictureAspectRatio
      ? hotspots.map(({ x, y, testo: text }) => (
          <CustomTooltip
            key={`tooltip-${x}-${y}`}
            title={
              <Typography
                variant="h6"
                style={{
                  textTransform: "none",
                  WebkitTextFillColor: "black",
                  textAlign: "center",
                  padding: "4px 8px",
                }}
                className="notSelectable"
                dangerouslySetInnerHTML={{
                  __html: linkifyHtml(sanitizeYaml(text), {
                    target: "_blank",
                    attributes: {
                      class: "underlineOnHover",
                    },
                  }),
                }}
              />
            }
            enterTouchDelay={0}
            arrow
            placement="top"
            disableFocusListener
          >
            <IconButton
              style={{
                position: "absolute",
                left: `calc(${
                  (parentAspectRatio || screenAspectRatio) < pictureAspectRatio
                    ? (1 +
                        (x * pictureAspectRatio) /
                          (parentAspectRatio || screenAspectRatio)) *
                        50 +
                      "%"
                    : (1 + x) * 50 + "%"
                } - 20px)`,
                top: `calc(${
                  (parentAspectRatio || screenAspectRatio) > pictureAspectRatio
                    ? (1 +
                        (y * (parentAspectRatio || screenAspectRatio)) /
                          pictureAspectRatio) *
                        50 +
                      "%"
                    : (1 + y) * 50 + "%"
                } - 20px)`,
                color: "black",
                background: "white",
                filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))",
              }}
              disableTouchRipple
            >
              <SvgIcon>
                <svg viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
                  />
                </svg>
              </SvgIcon>
            </IconButton>
          </CustomTooltip>
        ))
      : null
  }
}
